// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3iHNA","content":"GlobalSearch_content__uVrJL"};